import styled from "@emotion/styled";
import { Divider as MuiDivider } from "@mui/material";
import { spacing } from "@mui/system";

const Divider = styled(MuiDivider)(spacing);

export default Divider;
